
export const ErrorMsg = ({ error }) => {
    let errMsg =error ? error : "";
    let formatMsg =
      errMsg &&
      (errMsg.charAt(0).toUpperCase() + errMsg.slice(1))
        .replace(/[A-Z]/g, " $&")
        .trim();
    return ( 
      <div className="error-message-style" >
        {formatMsg}
      </div>
    );
  };